import { render } from "./RedTitleRow.vue?vue&type=template&id=bf4613b4"
import script from "./RedTitleRow.vue?vue&type=script&lang=js"
export * from "./RedTitleRow.vue?vue&type=script&lang=js"

import "./RedTitleRow.vue?vue&type=style&index=0&id=bf4613b4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__